import { Directive, ElementRef, Renderer2, OnInit, OnDestroy, DoCheck, HostBinding, HostListener, OnChanges, Input } from '@angular/core';
import { Observable, fromEvent, merge, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[appAnimationSlideStep]'
})
export class AnimationSlideStep implements OnChanges {

    @HostBinding('class.slide_down') slideDown = false;
    @HostBinding('class.slide_up') slideUp = false;
    @HostBinding('class.forceNone') forceNone = false;

    @Input() valueStep: number;

    constructor(private el: ElementRef) {
    }

    ngOnChanges() {
        console.log('First', this.el.nativeElement.classList)
        // console.log('teste')
        const currentDisplayValue = getComputedStyle(this.el.nativeElement).display;
        setTimeout(() => {
            if (this.valueStep != 0) {
                console.log(this.el.nativeElement)
                this.applyAnimation(this.el.nativeElement.hasAttribute('hidden'));
            }
        }, 50);
    }

    private applyAnimation(hasHidden: boolean): void {
        console.log('hasHidden', hasHidden)
        console.log('classes:', this.el.nativeElement.getAttribute('class'));
        console.log('slide_down', this.el.nativeElement.classList.contains('slide_down'))
        if (!hasHidden) {
            this.slideDown = true;
            this.slideUp = false;
        } else if (hasHidden) {
            this.slideDown = false;
            this.slideUp = true;
            setTimeout(() => {
                // console.log(this.el.nativeElement.style.display)
                // this.forceNone = true
            }, 950);
        }
    }
}